import React from "react";
import styled from "styled-components";

const GameTabs = ({ gamesFormat, gameStep, onSelectStep }) => {
  const gamesCount =
    gamesFormat === "PA3" ? 3 : gamesFormat === "BO5" ? 5 : 1;

  const items = [];
  for (let i = 0; i < gamesCount; i++) {
    items.push(
      <GameTab
        key={i}
        $active={gameStep === i}
        onClick={() => onSelectStep(i)}
      >
        <GameTabLabel>Partida</GameTabLabel> {i + 1}
      </GameTab>
    );
  }

  return <GameTabsRow>{items}</GameTabsRow>;
};

const GameTabsRow = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const GameTab = styled.div`
  padding: 0.4rem 0.85rem;
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ $active }) => ($active ? "#000" : "var(--v-fg-muted)")};
  background: ${({ $active }) =>
    $active ? "var(--v-mint)" : "rgba(255,255,255,0.04)"};
  border-radius: 20px;
  cursor: pointer;
  transition: background var(--v-transition);

  &:hover {
    background: ${({ $active }) =>
      $active ? "var(--v-mint)" : "rgba(255,255,255,0.08)"};
  }
`;

const GameTabLabel = styled.span`
  @media (max-width: 500px) {
    display: none;
  }
`;

export default GameTabs;
